import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppBar from "@/components/@common/AppBar";
import MarketGNB from "@/components/common/GNB/MarketGNB";
import Footer from "@/containers/Layout/Footer";
import { useAppBar } from "@/hooks/useAppBar";
import { cn } from "@/lib/utils";
import { IconV2, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import MyPageLayout from "./MyPageLayout";
const MyPageSubLayout = (param)=>{
    let { title , showBack =true , showPcBack =false , showHeaderBorder =true , onBack , rightAction , children  } = param;
    const router = useRouter();
    const { items: appBarItems , activeKey: appBarActiveKey  } = useAppBar();
    const handleBack = onBack !== null && onBack !== void 0 ? onBack : ()=>router.back();
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex min-h-screen flex-col bg-gray-50",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "sticky top-0 z-[800] hidden lg:block",
                children: /*#__PURE__*/ _jsx(MarketGNB, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: cn("sticky top-0 z-[800] flex h-[52px] items-center gap-3 bg-white px-5 lg:hidden", showHeaderBorder && "border-b border-gray-50"),
                        children: [
                            showBack && /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                "aria-label": "뒤로가기",
                                onClick: handleBack,
                                className: "shrink-0",
                                children: /*#__PURE__*/ _jsx(IconV2.ArrowLeft, {
                                    size: "md",
                                    className: "text-gray-700"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle1",
                                className: "text-strong flex-1",
                                children: title
                            }),
                            rightAction
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(MyPageLayout, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "hidden pt-8 lg:mb-5 lg:flex lg:items-center lg:gap-3",
                                children: [
                                    showPcBack && /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        "aria-label": "뒤로가기",
                                        onClick: handleBack,
                                        className: "shrink-0",
                                        children: /*#__PURE__*/ _jsx(IconV2.ChevronLeft, {
                                            size: "md",
                                            className: "text-gray-700"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "h5",
                                        className: "text-strong",
                                        children: title
                                    })
                                ]
                            }),
                            children
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Footer, {}),
            /*#__PURE__*/ _jsx(AppBar, {
                items: appBarItems,
                activeKey: appBarActiveKey
            })
        ]
    });
};
export default MyPageSubLayout;
